import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
    backgroundColor: '#8e24aa',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  grid: {
    marginTop: '20px',
    marginButtom: '20px',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  details: {
    '& span': {
      marginRight: '20px',
      fontWeight: 600,
      fontSize: '1rem',
    },
  },
  detailsHover: {
    '& span': {
      marginLeft: '20px',
      fontWeight: 600,
      fontSize: '1rem',
      color: '#02c102',
    },
  },
  btnEye: {
    marginRight: '20px',
    '& span': {
      marginRight: 0,
    },
  },
  divStyle: {
    padding: '4px',
    listStyle: 'none',
    background: '#c8f7ec',
    borderRadius: '5px',
    '& span': {
      fontSize: '15px',
      fontWeight: 500,
    },
  },
}));
